// VALIDACIÓN STEP 1
const ValidateStep1 = (form) => {
    let statusValidation = false;
    let newValidations = {};

    // * NIM
    if (!form.nim || form.nim.trim() === "") {
        newValidations.nim_valid = true;
        statusValidation = true;
    } else {
        newValidations.nim_valid = false;
    }

    // * PASSWORD
    if (!form.password || form.password.trim() === "") {
        newValidations.password_valid = true;
        statusValidation = true;
    } else {
        newValidations.password_valid = false;
    }

    // * DATE
    if (!form.date) {
        newValidations.date_valid = true;
        statusValidation = true;
    } else {
        newValidations.date_valid = false;
    }

    // * AMOUNT
    if (!form.amount || Number(form.amount) <= 0) {
        newValidations.amount_valid = true;
        statusValidation = true;
    } else {
        newValidations.amount_valid = false;
    }

    return {
        statusValidation,
        newValidations
    };
};

export default ValidateStep1;